import { render } from "./ProcessPage.vue?vue&type=template&id=921450c6&scoped=true"
import script from "./ProcessPage.vue?vue&type=script&lang=js"
export * from "./ProcessPage.vue?vue&type=script&lang=js"

import "./ProcessPage.vue?vue&type=style&index=0&id=921450c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-921450c6"]])

export default __exports__